module.exports = __webpack_public_path__ + "img/lemniscata_info_bernoulli.02936883.jpg";